import React from 'react';
import { Moon, Sun } from 'lucide-react';

export function ThemeSwitcher() {
  const getDefaultTheme = (): string => {
    let savedTheme = '';
    if (typeof window !== `undefined`) {
      savedTheme = window.localStorage.getItem('theme');
    }
    return savedTheme ? savedTheme : 'light';
  };

  const [isDark, setIsDark] = React.useState(getDefaultTheme());

  React.useEffect(() => {
    if (isDark === 'dark') {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }

    typeof window !== `undefined` && window.localStorage.setItem('theme', isDark);
  }, [isDark]);
  return (
    <>
      <button
        type='button'
        className='flex items-center'
        onClick={() => setIsDark(isDark === 'dark' ? 'light' : 'dark')}
        aria-label='Theme switcher'
      >
        <span className='sr-only'>Theme Switcher</span>
        <Sun
          className='h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0'
          strokeWidth={1}
        />
        <Moon
          className='absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100'
          strokeWidth={1}
        />
      </button>
    </>
  );
}
